import React from 'react';
import { Link } from 'react-router-dom';
import {
    Box,
    Flex,
    Text,
    Button,
    Stack,
    useColorModeValue,
    Image,
    Menu,
    MenuButton,
    MenuList,
    IconButton, MenuItem,
} from '@chakra-ui/react';

import {
    MenuItemOption,
    MenuGroup,
    MenuOptionGroup,
    MenuDivider,
} from '@chakra-ui/react'

import Logo from '../images/logowhite.png';
import { ColorModeSwitcher } from '../ColorModeSwitcher';

import { HamburgerIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { BsHouse, BsHouseFill, BsGiftFill, BsFillInfoCircleFill } from 'react-icons/bs';

const navbarFontSize = 24;

const data = [
    {"name": "Home", "url": "/", "icon": BsHouseFill},
    {"name": "Products", "url": "/products", "icon": BsGiftFill, "subItems": [
        {"name": "SunriseRGB", "url": "/products/sunrisergb"},
        {"name": "Omni Dial", "url": "/products/omnidial"},
        {"name": "Z3 Leo", "url": "/products/z3leo"}
    ]},
    {"name": "About Us", "url": "/about", "icon": BsFillInfoCircleFill},
];

const CustomMenuItem = (props) => {
    const { children, isLast, to = '/', ...rest } = props;
    return (
        <Text
            mb={{ base: isLast ? 0 : 8, sm: 0 }}
            mr={{ base: 0, sm: isLast ? 0 : 8 }}
            display="block"
            fontWeight="bold"
            fontSize={navbarFontSize}
            transition="color 0.15s ease"
            _hover={{color: "rgba(125, 125, 125, 1)"}}
            {...rest}
        >
            <Link to={to}>{children}</Link>
        </Text>
    );
};

export default function Navbar(props) {
    const [show, setShow] = React.useState(false);
    const toggleMenu = () => setShow(!show);

    return (

        <Flex
            as="nav"
            align="center"
            justify="space-between"
            wrap="wrap"
            w="100%"
            minH="85px"
            mb={8}
            p={5}
            pt={5}
            pb={5}
            position="sticky" // Set position to sticky
            top="0" // Stick to the top
            zIndex="999" // Ensure it appears above other content
            bg="rgba(255, 255, 255, 0.1)"
            backdropFilter="blur(10px)"
            borderBottom="1px solid rgba(255, 255, 255, 0.2)"
            shadow="dark-lg"
            {...props}
        >
            <Flex align="center">

                <Box display={{ base: 'block' }}>
                    <Link to="/">
                        <Image
                            src={Logo}
                            w="150px"
                            color={['white', 'white', 'primary.500', 'primary.500']}
                        />
                    </Link>
                </Box>

            </Flex>

            <Box display={{ base: "block", md: "None" }}>
                <Menu>
                    <MenuButton
                        as={IconButton}
                        aria-label='Options'
                        icon={<HamburgerIcon w={8} h={8}/>}
                        bg="transparent"
                        color="#ffffff"
                        // variant='outline'
                    />
                    <MenuList
                        bg="rgba(20, 20, 20, 0.8)"
                        backdropFilter="blur(15px)"
                        border="1px solid rgba(255, 255, 255, 0.2)"
                    >

                        {
                            data.map((item, index) =>

                                <React.Fragment key={index}>
                                    <Link to={item.url} style={{ textDecoration: 'none' }}>
                                        <MenuItem
                                            bg="transparent"
                                            icon={<Box as={item.icon} w={6} h={6}/>}
                                            to={item.url}
                                            fontFamily="oswald"
                                            fontSize={navbarFontSize}
                                            _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                                        >
                                            {item.name}
                                        </MenuItem>
                                    </Link>

                                    {item.subItems && item.subItems.map((subItem, subIndex) => (
                                        <Link key={`sub-${subIndex}`} to={subItem.url} style={{ textDecoration: 'none' }}>
                                            <MenuItem
                                                bg="transparent"
                                                fontFamily="oswald"
                                                fontSize={navbarFontSize * 0.8}
                                                pl={12}
                                                _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                                            >
                                                {subItem.name}
                                            </MenuItem>
                                        </Link>
                                    ))}

                                    {index === data.length - 1 ? null : <MenuDivider />}
                                </React.Fragment>
                            )
                        }

                    </MenuList>
                </Menu>

            </Box>


            <Box
                display={{ base: show ? 'block' : 'none', md: 'block' }}
                flexBasis={{ base: '100%', md: 'auto' }}
            >
                <Flex
                    align={['center', 'center', 'center', 'center']}
                    justify={['center', 'space-between', 'flex-end', 'flex-end']}
                    direction={['column', 'row', 'row', 'row']}
                    pt={[4, 4, 0, 0]}
                >

                    {
                        data.map((item, index) => (
                            item.subItems ? (
                                <Menu key={index} trigger="hover">
                                    <MenuButton
                                        as={Button}
                                        rightIcon={<ChevronDownIcon />}
                                        bg="transparent"
                                        color="#ffffff"
                                        fontSize={navbarFontSize}
                                        fontFamily="oswald"
                                        fontWeight="bold"
                                        mb={{ base: 0, sm: 0 }}
                                        mr={{ base: 0, sm: index === data.length - 1 ? 0 : 8 }}
                                        _hover={{ color: "rgba(125, 125, 125, 1)", bg: "transparent" }}
                                        _active={{ bg: "transparent" }}
                                        _focus={{ boxShadow: "none" }}
                                        p={0}
                                        h="auto"
                                        display="flex"
                                    >
                                        <Link to={item.url} style={{ textDecoration: 'none' }}>
                                            {item.name}
                                        </Link>
                                    </MenuButton>
                                    <MenuList
                                        bg="rgba(20, 20, 20, 0.8)"
                                        backdropFilter="blur(15px)"
                                        border="1px solid rgba(255, 255, 255, 0.2)"
                                    >
                                        {item.subItems.map((subItem, subIndex) => (
                                            <Link key={subIndex} to={subItem.url} style={{ textDecoration: 'none' }}>
                                                <MenuItem
                                                    bg="transparent"
                                                    fontFamily="oswald"
                                                    fontSize={navbarFontSize * 0.8}
                                                    _hover={{ bg: "rgba(255, 255, 255, 0.1)" }}
                                                >
                                                    {subItem.name}
                                                </MenuItem>
                                            </Link>
                                        ))}
                                    </MenuList>
                                </Menu>
                            ) : (
                                <CustomMenuItem key={index} to={item.url} fontFamily="oswald">{item.name}</CustomMenuItem>
                            )
                        ))
                    }

                </Flex>
            </Box>
        </Flex>
    );
};